import TableCommonHook from '@/pages/opinion/components/TableCommonHook';
import { useGameStoreColumns } from '@/pages/opinion/components/TableCommonHook/hooks/useGameStoreColumns';
import { useRequestLatestEditLog } from '@op/pages/feeds/hooks/useFeedsRequest';
import React from 'react';
import { connect } from 'umi';

function GameStoreTable({
  gameInfo,
  sortBy,
  setSortBy,
  topicList,
  isExcludeInvalid,
  setIsExcludeInvalid,
  total,
  records,
  hasPageable = true,
  tableSticky = true,
  pageInfo,
  setPageInfo,
  loading = false,
  languages,
  setLanguages,
  setApiLoading,
  renderKeyword,
  wholeGameInfo,
}: any) {
  const { logCommentMap, loading: logLoading } = useRequestLatestEditLog({
    data: records as any,
    setApiLoading,
  });

  const { columns, sortColumns } = useGameStoreColumns({
    gameInfo,
    languages,
    topicList,
    sort: sortBy,
    setSort: setSortBy,
    isExcludeInvalid,
    setIsExcludeInvalid,
    logCommentMap,
    logLoading,
    setLanguages,
    renderKey: renderKeyword,
    wholeGameInfo,
  });

  return (
    <TableCommonHook
      recordKey="comment_uin"
      records={records}
      tableSticky={tableSticky}
      sortColumns={sortColumns}
      hasPageable={hasPageable}
      sortInfo={[sortBy, setSortBy]}
      pageInfo={pageInfo}
      setPageInfo={setPageInfo}
      columns={columns}
      loading={loading}
      total={total}
    />
  );
}

export default connect((state: any) => {
  const { opinionCommon } = state;

  return {
    wholeGameInfo: opinionCommon.wholeGameInfo,
  };
})(GameStoreTable);
